import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7502 4.50001C15.7502 3.80263 15.9931 3.12702 16.4372 2.58933C16.8813 2.05163 17.4988 1.68546 18.1837 1.55375C18.8685 1.42204 19.5778 1.53303 20.1897 1.86764C20.8015 2.20225 21.2777 2.73957 21.5363 3.38722C21.7949 4.03487 21.8198 4.75238 21.6068 5.41641C21.3937 6.08044 20.9559 6.64948 20.3687 7.02572C19.7815 7.40195 19.0816 7.56187 18.3893 7.47797C17.697 7.39408 17.0556 7.07161 16.5752 6.56601L8.15423 11.245C8.28289 11.7401 8.28289 12.2599 8.15423 12.755L16.5752 17.434C17.0785 16.9049 17.7574 16.5775 18.4848 16.5132C19.2122 16.4489 19.9381 16.6521 20.5263 17.0847C21.1146 17.5173 21.5249 18.1496 21.6803 18.8631C21.8357 19.5766 21.7255 20.3223 21.3705 20.9603C21.0154 21.5984 20.4398 22.0851 19.7515 22.3291C19.0633 22.5731 18.3097 22.5577 17.632 22.2858C16.9543 22.0139 16.399 21.5042 16.0702 20.8521C15.7415 20.2001 15.6618 19.4506 15.8462 18.744L7.42523 14.066C7.01209 14.501 6.47801 14.8021 5.89198 14.9305C5.30595 15.0589 4.6949 15.0086 4.13773 14.7862C3.58056 14.5638 3.10288 14.1794 2.76637 13.6827C2.42987 13.1861 2.25 12.5999 2.25 12C2.25 11.4001 2.42987 10.8139 2.76637 10.3173C3.10288 9.82061 3.58056 9.43624 4.13773 9.21382C4.6949 8.99139 5.30595 8.94112 5.89198 9.0695C6.47801 9.19788 7.01209 9.49902 7.42523 9.93401L15.8462 5.25501C15.7823 5.00844 15.7501 4.75473 15.7502 4.50001Z"
        fill={colorValue}
      />
    </svg>
  );
};
